import script from "./form-buttons.vue?vue&type=script&lang=js"
export * from "./form-buttons.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/pages/components/form-buttons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ed5aff8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ed5aff8', __exports__)) {
    console.log('reload')
    api.reload('3ed5aff8', __exports__)
  }
  
}


export default __exports__